import type { FoodActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: FoodActivity;
}

export const FoodActivityTitle = forwardRef<HTMLDivElement, Props>(
  function FoodActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity,
      ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    if (!activity.carbs) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {polyglot.t(
          "unit.num_grams",
          {
            grams: round(
              activity.carbs,
              1,
            ).toLocaleString(polyglot.locale()),
          },
        )}
      </div>
    )
  },
)
